import { config } from '../config';
import { isHermesApp } from '../utils/device';

import { getDeviceType } from './appnexus/getDeviceType';
import { unleash } from './unleash';

import type { DatadogLogs } from '@datadog/browser-logs';

const {
  datadog: {
    logs: {
      clientToken,
      service = 'frontend',
      env = 'development',
      version,
      level,
    },
  },
  provider,
} = config;

let datadogPromise: Promise<DatadogLogs>;

const getFeatureFlags = () => {
  return unleash
    .getAllToggles()
    .reduce<Record<string, string>>((flags, toggle) => {
      flags[toggle.name] = toggle.variant.name;

      return flags;
    }, {});
};

const initDatadog = () => {
  return new Promise<DatadogLogs>((resolve) => {
    window.DD_LOGS?.onReady(() => {
      window.DD_LOGS?.init({
        clientToken,
        service,
        env,
        version,
        site: 'datadoghq.eu',
      });

      window.DD_LOGS?.setGlobalContext({
        custom: {
          provider,
          deviceType: getDeviceType(),
          isApp: isHermesApp,
          featureFlags: getFeatureFlags(),
        },
      });
      window.DD_LOGS?.logger.setLevel(level);

      resolve(window.DD_LOGS!);
    });
  });
};

export const getDatadog = () => {
  if (datadogPromise) {
    return datadogPromise;
  }

  datadogPromise = initDatadog();

  return datadogPromise;
};
